export const isAuthorized = ({ functions = [], feature = '' }) => {
  return functions.some(funcion => funcion.Function.acronym === feature)
}

 export const moduleAuthorized = ({ functions = [], feature = [] }) => {
   return functions.some(funcion => feature.includes(funcion.acronym))
 }

 export const getToken = () => {
  if(localStorage.getItem('token')) return localStorage.getItem('token')
  else{
    const a = JSON.parse(localStorage.getItem("asofix-redux-store"))
    return a?.common?.user?.token || false 
  }
}